import React, { useState, useContext, useEffect, useRef } from "react";
// import { getAuth, updateProfile, signOut } from "firebase/auth";
// import { db } from "../Firebase/FirebaseConfig";
// import {
//   ref,
//   uploadBytesResumable,
//   getDownloadURL,
//   getStorage,
// } from "firebase/storage";
import { Link, useNavigate } from "react-router-dom";
import { Fade } from "react-reveal";
// import toast, { Toaster } from "react-hot-toast";
import logo from "../../assets/images/mayaLogo.png";
import { FiEdit2, FiLogOut } from "react-icons/fi";
import { AuthContext } from "../../Context/UserContext";
import WelcomePageBanner from "../../assets/images/WelcomePageBanner.png";
import profileDefault from "../../assets/images/user.png";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { TbArrowBackUp } from "react-icons/tb";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { CiCirclePlus } from "react-icons/ci";
import axiosClient from "../../axios-client";
import { BsPersonLock } from "react-icons/bs";
// Password Modal Component

function Profile() {
  const { setUser, setToken, user, setProfileId } = useContext(AuthContext);
  const [profiles, setProfiles] = useState([]);

  const [isEditMode, setIsEditMode] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCheckPwdModalOpen, setIsCheckPwdModalOpen] = useState(false);
  const [modalAction, setModalAction] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [id, setId] = useState();
  const [profile, setProfile] = useState();
  const [ErrorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    // Fetch profiles by user
    const fetchProfiles = async () => {
      try {
        const response = await axiosClient.get(`/profiles/user/${user?.id}/`); // Replace with your API endpoint
        setProfiles(response.data);
      } catch (err) {
        // console.error(err);
        setError("Failed to fetch profiles.");
      } finally {
        setLoading(false);
      }
    };

    fetchProfiles();
  }, [user.id, user]);


  // const handleProfileClick = (profileId) => {
  //   if (isEditMode) {
  //     // Redirect to edit page
  //     navigate(`/edit-profile/`,{
  //       state: {
  //         profileId: profileId,
  //       }
  //   });
  //   } else {
  //     setProfileId(profileId)      
  //     navigate(`/home`);
  //   }
  // };
  const handleProfileClick = (profileId, profile, action) => {
    setSelectedProfile(profileId);
    setModalAction(action);
    if (profile?.password) {
      setIsModalOpen(true)
    }
    else {
      if (action === "home") {
        setProfileId(profileId);
        navigate(`/home`);
      } else if (action === "edit") {
        setProfileId(profileId);
        navigate(`/edit-profile`, {
          state: {
            profileId: profileId,
          },
        });
      }
    }

    // setIsModalOpen(true);
    setId(profileId);
    setProfile(profile)
  };
  const onLogout = (ev) => {
    ev.preventDefault();
    setUser({});
    setProfileId(null)
    setToken(null);
    // localStorage.removeItem("profileId");
    navigate("/signin")
  };
  const handlePasswordSubmit = async () => {
    try {
      // Verify the password with the API
      const response = await axiosClient.post(`/verify-profile-password/`, {
        password,
        profile_id: id,
      });

      // Check if the backend confirms the password is correct
      if (response.data.success) {
        // Navigate based on the action
        if (modalAction === "home") {
          setProfileId(selectedProfile);
          navigate(`/home`);
        } else if (modalAction === "edit") {
          setProfileId(selectedProfile);
          navigate(`/edit-profile`, {
            state: {
              profileId: selectedProfile,
            },
          });
        }
      } else {
        // Handle incorrect password response
        toast.error("Mot de passe incorrect.", {
          position: "top-right",
          autoClose: 3000,
        });
        setPassword('')
      }
    } catch (err) {
      // Handle any kind of error, including network or server issues
      if (err.response && err.response.status === 400) {
        // Specifically handle incorrect password
        toast.error("Mot de passe incorrect.", {
          position: "top-right",
          autoClose: 3000,
        });
        setPassword('')
      } else {
        // For any other errors, show a generic error message
        // console.error("Password verification failed:", err);
        toast.error("Une erreur s'est produite.", {
          position: "top-right",
          autoClose: 3000,
        });
        setPassword('')
      }
    }
  };
  const handleNewProfile = () => {
    if (profiles.length >= 5) {
      toast.warning("Vous avez atteint le nombre maximum de profils autorisés (5).", {
        position: "top-right",
        autoClose: 3000,
      });
    }
    else {
      navigate("/new-profile")
    }
  }
  const handleNewPasswordSubmit = async () => {
    try {
      if(password!=confirmPassword){
        setErrorMessage("Le mot de passe et le mot de passe de confirmation ne correspondent pas.")
        return
      }
      
      // Send request to the backend to add/update the profile password
      const response = await axiosClient.put(`add-profile-password/${id}/`, {
        password: password,
        confirmPassword: confirmPassword,
      });

      // Handle success response
      if (response.data.success) {
        toast.success("Mot de passe ajouté avec succès.", {
          position: "top-right",
          autoClose: 3000,
        });

        // Navigate based on the action
        if (modalAction === "home") {
          setProfileId(selectedProfile);
          navigate(`/home`);
        } else if (modalAction === "edit") {
          navigate(`/edit-profile`, {
            state: {
              profileId: selectedProfile,
            },
          });
        }
      }
    } catch (err) {
      // Handle errors
      if (err.response && err.response.data.error) {
        // Specific error from the backend
        toast.error(err.response.data.error, {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        // Generic error
        // console.error("Failed to update password:", err);
        toast.error("Une erreur s'est produite.", {
          position: "top-right",
          autoClose: 3000,
        });
      }

      // Reset the password fields
      setPassword("");
      setConfirmPassword("");
    }
  };

  // const handleNewPasswordSubmit = async () => {
  //   if (password !== confirmPassword) {
  //     setErrorMessage("Les mots de passe ne correspondent pas.");
  //     return;
  //   }

  //   try {
  //     const response = await axiosClient.put(`add-profile-password/${id}/`, {
  //       password: password,
  //       confirmPassword: confirmPassword,
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       alert("Mot de passe ajouté avec succès !");
  //       setIsModalOpen(false);
  //     } else {
  //       alert(data.error || "Une erreur est survenue.");
  //     }
  //   } catch (error) {
  //     console.error("Error:", error);
  //     alert("Une erreur est survenue.");
  //   }
  // };

  const handleDeleteSubscription = async () => {
    setLoading(true); // Start loading
    try {
      // Verify the password before deleting
      const verifyResponse = await axiosClient.post("verify-password/", {
        user_id: user?.id,
        password,
      });


      // If password is correct, proceed to delete profile
      await axiosClient.put(`/stop-subscription/${user.id}/`);
      toast.success("L'abonnement a été arrêté avec succès.", {
        position: "top-right",
        autoClose: 3000,
      });
      setUser({});
      setProfileId(null)
      setToken(null);
      // localStorage.removeItem("profileId");
      navigate("/signin")
    } catch (err) {
      console.log(err);
      
      if (err.response && err.response.status === 400) {
        toast.error("Mot de passe incorrect.", {
          position: "top-right",
          autoClose: 3000,
        });
      } else {
        // Handle other errors
        // console.error("Erreur lors de la suppression du profil", err);
        toast.error("Erreur lors d'arrêt d'abonnement.", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } finally {
      setLoading(false); // Stop loading
      setIsCheckPwdModalOpen(false);
      setPassword("")
    }
  };

  return (
    <div>
      <ToastContainer />

      <div
        className="relative flex h-screen justify-center items-center"
        style={{
          background: `url(${WelcomePageBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <Link
          onClick={onLogout}
          className="absolute top-2 right-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
          title="Se déconnecter"
        >
          <FiLogOut size={"26px"} className="text-orange-500" />
        </Link>
        <Link
          onClick={() => navigate(-1)}
          className="absolute top-2 left-2 flex items-center justify-center bg-black/20 rounded-full p-2.5 cursor-pointer"
          title="Se déconnecter"
        >
          <TbArrowBackUp size={"26px"} className="text-orange-500" />
        </Link>
        {/* {isMyListUpdated ? (
          <Toaster
            toastOptions={{
              style: {
                padding: "1.5rem",
                backgroundColor: "##f4fff4",
                borderLeft: "6px solid green",
              },
            }}
          />
        ) : null} */}
        <div className=" p-5 md:p-12 rounded-md">
          <div className="py-5 flex justify-center items-center ">
            <img
              className="h-10 cursor-pointer w-18"
              src={logo}
              alt="NETFLIX"
            />
          </div>
          <h1 className=" text-center text-xl text-white mb-8 ">
            Sélectionnez votre profil 
          </h1>

          <div className="flex flex-wrap gap-5 justify-center items-center mb-8">
            {profiles.map((profile) => (
              <div
                key={profile.id}
                onClick={() =>
                  handleProfileClick(profile.id, profile, isEditMode ? "edit" : "home")
                }
                className="text-center relative"
              >

                {profile?.avatar ? (
                  <img
                    className="border-2 border-orange-400 w-24 h-24 rounded-full cursor-pointer"
                    src={profile.avatar}
                    alt={profile.username}
                  />
                ) : (
                  <img
                    className="border-2 border-orange-400 w-24 h-24 rounded-full cursor-pointer"
                    src={profileDefault}
                  />
                )}
                {isEditMode && (
                  <div className="absolute top-0 right-0 bg-white rounded-full p-1">
                    <FiEdit2 className="text-orange-500 cursor-pointer" />
                  </div>
                )}
                <h5 className="text-center text-lg font-semibold leading-tight tracking-tight py-3 text-white md:text-lg">
                  {profile?.username}
                </h5>
              </div>
            ))}
            <div className="mb-14">
              <CiCirclePlus onClick={handleNewProfile} className="h-12 w-12 text-orange-300 cursor-pointer" />
            </div>
          </div>
          <div className="w-full flex items-center justify-center">
            <button
              onClick={() => setIsEditMode(!isEditMode)} // Toggle edit mode
              style={{
                background: "linear-gradient(to right, #eb6820, #fd9358)",
              }}
              className="lg:w-[100%] max-w-[300px] px-14 py-3 mt-3 font-medium text-white rounded-md flex items-center justify-center"
            >
              {isEditMode ? "Terminer la modification" : "Modifier les profils"}
            </button>
          </div>
          {user.has_active_subscription &&
          <Link to={"/my-subscription"}>
            <h1 className=" text-center text-sm font-semibold leading-tight tracking-tight pt-5 text-white">
              Mon abonnement
            </h1>
         
          </Link> }
          {user?.stripe_customer_id &&
           <Link onClick={() => setIsCheckPwdModalOpen(true)}>
           <h1 className=" text-center text-sm font-semibold leading-tight tracking-tight py-5 text-white">
             Arrêter cet abonnement
           </h1>

         </Link>
        //   : 
        //   <Link to={"/abonnement"}>
        //   <h1 className=" text-center text-sm font-semibold leading-tight tracking-tight py-5 text-white">
        //     S'abonner
        //   </h1>

        // </Link>
        }
         
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          {profile?.password ? (
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <h2 className="text-lg font-semibold mb-4">Entrer le mot de passe de profil</h2>
              <input
                type="password"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
              />
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded-md"
                >
                  Annuler
                </button>
                <button
                  disabled={!password}
                  onClick={handlePasswordSubmit}
                  className="px-4 py-2 bg-orange-500 text-white rounded-md"
                >
                  Continuer
                </button>
              </div>
            </div>
          ) : (
            <div className="bg-white p-6 rounded-lg shadow-lg w-96">
              <h2 className="text-lg font-semibold mb-4">Ajouter un mot de passe de profil</h2>
              {ErrorMessage && (
                <h1 className="flex text-sm text-white p-3 mb-3 bg-red-500 rounded ">

                  {ErrorMessage}
                </h1>
              )}
              <input
                type="password"
                placeholder="Mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
              />
              <input
                type="password"
                placeholder="Confirmer votre mot de passe"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
              />
              <div className="flex justify-end gap-3">
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="px-4 py-2 bg-gray-500 text-white rounded-md"
                >
                  Annuler
                </button>
                <button
                  disabled={!password && !confirmPassword}
                  onClick={handleNewPasswordSubmit}
                  className="px-4 py-2 bg-orange-500 text-white rounded-md"
                >
                  Continuer
                </button>
              </div>
            </div>
          )}

        </div>

      )}
      {isCheckPwdModalOpen &&
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-semibold mb-4">Entrer le mot de passe de compte</h2>
            <p className="text-sm text-gray-500 mb-4">
              Veuillez entrer votre mot de passe pour confirmer l'arrêt d'abonnement.
            </p>

            <input
              type="password"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-gray-300 rounded-md px-3 py-2 mb-4 focus:outline-none focus:ring-1 focus:ring-gray-200"
            />
            <div className="flex justify-end gap-3">
              <button
                onClick={() => setIsCheckPwdModalOpen(false)}
                className="px-4 py-2 bg-gray-500 text-white rounded-md"
              >
                Annuler
              </button>
              <button
                disabled={!password}
                onClick={handleDeleteSubscription}
                className="px-4 py-2 bg-orange-500 text-white rounded-md"
              >
                {loading ? "Arrêt..." : "Arrêter"}
              </button>
            </div>
          </div>
        </div>
      }

    </div>
  );
}

export default Profile;
